<script setup lang="ts">
import { NXGDSButton, NXGDSButtonVariants, NXGDSButtonSizes } from '@nsftx/seven-nxg-design-system'
import { redirectToSboLogin } from '@/utils/redirectToSboLogin'
</script>

<template>
  <div data-cy="helpButtonFooter">
    <NXGDSButton
      width="56px"
      :variant="NXGDSButtonVariants.secondary"
      :size="NXGDSButtonSizes.big"
      icon="user-b"
      @click="redirectToSboLogin()"
    />
  </div>
</template>
